export default __webpack_public_path__ + "static/media/icons8-react-native.435afc9f.png";